import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

import ResponsiveDiv from 'components/common/ResponsiveDiv'
import Present from 'components/common/Present'

const Title = ({ children }) => {
  return (
    <ResponsiveDiv>
      <Typography variant="h3">{children}</Typography>
    </ResponsiveDiv>
  )
}

const VenderIntro = ({ venderIntroduction, containerId }) => {
  return (
    <Typography>
      {venderIntroduction?.map((module) => {
        return !module?.isVisible ? null : (
          <Box
            mb={
              module?.type === 'graphicMore' ||
              module?.type === 'publicitySmall' ||
              module?.type === 'banner'
                ? { xs: 12, md: 18 }
                : { xs: 18, md: 24 }
            }
          >
            <Present
              key={module?._id}
              data={module}
              isServicePage={true}
              lazy={false}
              lazyOptions={{ containerId }}
            />
          </Box>
        )
      })}
    </Typography>
  )
}

export default VenderIntro
